import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { TranslationView, getTranslationOptions } from '@/module/Author/Translation';

export const Route = createFileRoute('/_auth/author/_author/translation/_translation/$translationId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { translationId } = Route.useParams();
  const { data: translation } = useSuspenseQuery(getTranslationOptions(translationId));

  return <TranslationView translation={translation} />;
}
